import productData from "../data/product-data.json";

// A one-line summary of the three options shown to the visitor, saved on the
// Shopify customer as custom.quiz_quote_summary so sales can see what was
// quoted even if the visitor never clicked a button. Prices match the quote
// screen: total including provincial tax, and the "as low as" price after the
// maximum available incentives.
//
// Example:
// "Ducted, NS | Best: Tosot $14,250 (as low as $9,250) | Better: Bosch ... | Good: ..."

const RANK_LABEL = { 1: "Best", 2: "Better", 3: "Good" };

const dollars = (value) =>
  `$${Math.round(value || 0).toLocaleString("en-CA")}`;

// Same calculation as the quote card (Quote.jsx).
export const optionTotalWithTax = (option) => {
  const rate = productData.prov_tax_rate[option.province || "ON"] || 1.13;
  const subtotal = Math.round(option.total * 100) / 100;
  const tax = Math.round(option.total * (rate - 1) * 100) / 100;
  return Math.round((subtotal + tax) * 100) / 100;
};

export const buildQuoteSummary = (options = []) => {
  if (!options.length) return "";
  const first = options[0];
  const type = first.type === "Central" ? "Ducted" : "Ductless";
  const parts = [...options]
    .sort((a, b) => a.rank - b.rank)
    .map((option) => {
      const total = optionTotalWithTax(option);
      const asLowAs = Math.max(0, total - (option.grantAllowance || 0));
      const brand = String(option.title || "").split(" ")[0];
      return `${RANK_LABEL[option.rank] || option.rank}: ${brand} ${dollars(total)} (as low as ${dollars(asLowAs)})`;
    });
  return [`${type}, ${first.province}`, ...parts].join(" | ").slice(0, 255);
};
